import AuthReducer from './AuthReducer'
import React,{ createContext, useEffect, useReducer } from 'react'

const INITIAL_STATE = {
  //user: JSON.parse(localStorage.getItem('user')) || null,
  user: localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user'))
    : null,
  data: [],
  isFetching: false,
  message: '',
  error: false
}

export const AuthContext = createContext(INITIAL_STATE)

export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AuthReducer, INITIAL_STATE)

  useEffect(() => {
    localStorage.setItem('user', JSON.stringify(state.user))
  }, [state.user])

  return (
    <AuthContext.Provider
      value={{
        user: state.user,
        data: state.data,
        isFetching: state.isFetching,
        error: state.error,
        message: state.message,
        dispatch
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
